import script from "./LicensesContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LicensesContent.vue?vue&type=script&setup=true&lang=js"

import "./LicensesContent.vue?vue&type=style&index=0&id=6bd7d682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd7d682"]])

export default __exports__